module.exports = __webpack_public_path__ + "static/media/airQualityIndex.f8a0188f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/weather/svg/airQualityIndex.svg
// module id = 508
// module chunks = 0